export default "__VITE_ASSET__DGuJw7xE__"